// extracted by mini-css-extract-plugin
export default {"button":"AuthButton-module__button__7XQX0","variant":"AuthButton-module__variant__05HtQ","filled":"AuthButton-module__filled__JSlOP"};